import React, { Suspense, useEffect, useState } from "react";
import { clientIds, customLinkData, customMenuUISettings, responsiveSettings } from "../../../../config/clients/clients";
import DropDown from "../../../../component/dropdown/dropdown";
import Template7Fragment from "./Template7Fragment";
import Image from "../../../../component/image/Image";
import chevronOrange from "../../../../assets/images/clients/chevron-orange.svg";

import useClientConfig from "../../../../config/careers/clientConfig";

const CustomMegaMenu = (props: any) => {

    const { menuSettings, clientId } = props;
    const [navOpen, setNavOpen] = useState<boolean>(false);
    const [dropdownIcon, setDropdownIcon] = useState<boolean>(false);
    const [doesMenuActAsAccordion, setMenuActAsAccordion] = useState(false);
    const {clientSiteSettings, clientMenuSettings} = useClientConfig();
    const templateName = clientSiteSettings?.templateName;



    
    const [linkListData, setLinkListData] = useState<any>({
        id : "",
        linkList : []
    });

    useEffect(() => { 
        if (menuSettings) {
            setLinkListData(clientMenuSettings);
        }
    }, [customLinkData, menuSettings]);

    useEffect(() => {
        if(clientSiteSettings?.showDropDownIcon){
            setDropdownIcon(true);
        } else {
            setDropdownIcon(false);
        }
    });

    const toggleLinkListData = (currentId:any, toggle:boolean, doesMenuActAsAccordion?: boolean) => {
        setLinkListData((listItems:any) => {
            let modifiedList = listItems.linkList;
            let currentItemIndex = modifiedList.findIndex((item: { id: any; }) => item.id === currentId);
            if(doesMenuActAsAccordion && doesMenuActAsAccordion === true){
                if(modifiedList[currentItemIndex]["open"]){
                    modifiedList[currentItemIndex]["open"] = false;
                } else {
                    modifiedList[currentItemIndex]["open"] = true;
                }
            } 
            else if (modifiedList[currentItemIndex]) {
                modifiedList = modifiedList.map((item: any, index: number) => 
                    index === currentItemIndex ? { ...item, open: toggle } : item
                );
            }
    
            return {
                ...listItems,
                linkList : modifiedList
            };
          });
    };

    useEffect(() => {
        if (responsiveSettings.vyMenuBreakpoint && screen.width < responsiveSettings.vyMenuBreakpoint) {
            setMenuActAsAccordion(true);
        }
    }, []);

    //Mouse enter to toggle dropdown, acts as touch during mobile responsive
    const onMouseEnter = (currentId:any) => {
        toggleLinkListData(currentId, true, doesMenuActAsAccordion);
    };

    const onMouseLeave = (currentId:any) => {
        toggleLinkListData(currentId, false);
    };

    const toggleNavBar = () => {
        navOpen ? setNavOpen(false) : setNavOpen(true);

        if(navOpen) {
            document.body.classList.remove("menu-open-body");
        } else {
            document.body.classList.add("menu-open-body");
        }
    };

    const loadFragments = () => {
        let FragmentName = templateName.charAt(0).toUpperCase() + templateName.slice(1).replace(/_/g, "");
        if(FragmentName === "Template8"){
            FragmentName = "Template7";
        }
        const FragmentComponent = React.lazy(() => import(`./${FragmentName}Fragment`).catch(() => ({ default: () => <div>Not loading</div> })));
        return (
            <Suspense fallback={<></>}>
                <FragmentComponent menuSettings={menuSettings} />
            </Suspense>
        );
    };

    const loadTemplate7HeadTop = () => {
        const FragmentName = "Template7HeadTop";
        const FragmentComponent = React.lazy(() => import(`./${FragmentName}Fragment`).catch(() => ({ default: () => <div>Not loading</div> })));
        return (
            <Suspense fallback={<></>}>
                <FragmentComponent menuSettings={menuSettings} />
            </Suspense>
        );
    };

    const loadTemplate7ContactData = () => {
        const FragmentName = "Template7Contact";
        const FragmentComponent = React.lazy(() => import(`./${FragmentName}Fragment`).catch(() => ({ default: () => <div>Not loading</div> })));
        return (
            <Suspense fallback={<></>}>
                <FragmentComponent menuSettings={menuSettings} />
            </Suspense>
        );
    };

    return (
        <> 
            <header>
                <div className="header">
                    <div className="container-new">
                        {loadTemplate7HeadTop()}
                        <div className="head-parent">
                            <div className="head-left">
                                <div className="logo-new">
                                    <a href={menuSettings.homeLinkHref} rel="noreferrer" target="_blank">
                                        <img src={process.env.PUBLIC_URL + menuSettings.logoimg} className="cust-logo-desktop-img"/>
                                        <img src={process.env.PUBLIC_URL + menuSettings.moblogoimg}  className="cust-logo-mob-img" />
                                    </a>
                                </div>
                            </div>
                            <button className={navOpen ? "responsive-nav-btn menu-open" : "responsive-nav-btn menu-closed"} onClick={toggleNavBar}>
                                <img className="menu-open-icon" src={process.env.PUBLIC_URL + menuSettings.menuToggle}/>
                                <img className="menu-close-icon" src={process.env.PUBLIC_URL + menuSettings.menuToggleClose}/></button>
                            <div className="head-right">
                                
                                <nav className={navOpen ? "nav-open" : "nav-closed"}>
                                    <ul className="submenu-list">
                                        {linkListData?.linkList.map((listItem:any) => {
                                            return (
                                                <li 
                                                    key={listItem.href}
                                                    onMouseEnter={() => onMouseEnter(listItem.id)}
                                                    onMouseLeave={() => onMouseLeave(listItem.id)}
                                                    className={listItem.open ? "open" : ""}
                                                >
                                                    <a href={listItem.href} title={listItem.name} rel="noreferrer" target="_blank"> {listItem.name} {listItem.open}</a>  
                                                    <span className={dropdownIcon ? "menu-arrow-new" : "menu-arrow" } onClick={() => onMouseEnter(listItem.id)}>{ dropdownIcon ? <Image src={chevronOrange} /> : "" }</span>
                                                    {
                                                        (listItem.customMenuTemplate && listItem.customMenuTemplate === true) ? 
                                                            loadFragments()
                                                        : 
                                                        <DropDown submenuItems={listItem.submenu} menuType={listItem.subType} menuSettings={menuSettings}/>
                                                    }
                                                    
                                                </li>
                                            );
                                        })}
                                    </ul>
                                    {loadTemplate7ContactData()}
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};


export default CustomMegaMenu;